/**
 * Compare visual da row do Board (memo).
 * Re-render só se id/sla/selected/retorno/defeito (e campos do card) mudarem.
 */

function sameStr(a, b) {
  return String(a ?? '') === String(b ?? '');
}

function sameBool(a, b) {
  return Boolean(a) === Boolean(b);
}

/** Campos da OS que a row mostra / usa em flags. */
export function areBoardOrderVisualFieldsEqual(prevOrder, nextOrder) {
  if (prevOrder === nextOrder) return true;
  if (!prevOrder || !nextOrder) return false;

  return (
    sameStr(prevOrder.id, nextOrder.id) &&
    sameStr(prevOrder.TB02115_CODIGO, nextOrder.TB02115_CODIGO) &&
    sameStr(prevOrder.sla, nextOrder.sla) &&
    sameStr(prevOrder.tipo, nextOrder.tipo) &&
    sameStr(prevOrder.cliente, nextOrder.cliente) &&
    sameStr(prevOrder.TB01008_NOME, nextOrder.TB01008_NOME) &&
    sameStr(prevOrder.TB01008_FANTASIA, nextOrder.TB01008_FANTASIA) &&
    sameStr(prevOrder.equipamento, nextOrder.equipamento) &&
    sameStr(prevOrder.TB01010_RESUMIDO, nextOrder.TB01010_RESUMIDO) &&
    sameStr(prevOrder.TB01010_NOME, nextOrder.TB01010_NOME) &&
    sameStr(prevOrder.pedidoVinculado, nextOrder.pedidoVinculado) &&
    sameStr(prevOrder.TB02112_PAT, nextOrder.TB02112_PAT) &&
    sameStr(prevOrder.patrimonio, nextOrder.patrimonio) &&
    sameStr(prevOrder.TB02115_NUMSERIE, nextOrder.TB02115_NUMSERIE) &&
    sameStr(prevOrder.numeroSerie, nextOrder.numeroSerie) &&
    sameStr(prevOrder.TB02115_STATUS, nextOrder.TB02115_STATUS) &&
    sameStr(prevOrder.os_request_status, nextOrder.os_request_status) &&
    sameStr(prevOrder.OS_REQUEST_STATUS, nextOrder.OS_REQUEST_STATUS) &&
    sameStr(prevOrder.request_status, nextOrder.request_status) &&
    sameStr(prevOrder.defeito_alert, nextOrder.defeito_alert) &&
    sameStr(prevOrder.color_bg, nextOrder.color_bg) &&
    sameStr(prevOrder.boardTechnicianSection, nextOrder.boardTechnicianSection) &&
    sameBool(prevOrder.isPausaOficina, nextOrder.isPausaOficina) &&
    sameBool(prevOrder.isAguardandoAtendimento, nextOrder.isAguardandoAtendimento) &&
    sameBool(prevOrder.isAguardandoAssinatura, nextOrder.isAguardandoAssinatura) &&
    sameBool(prevOrder.RoteiroHoje === 1 || prevOrder.RoteiroHoje === true, nextOrder.RoteiroHoje === 1 || nextOrder.RoteiroHoje === true) &&
    sameStr(prevOrder.source, nextOrder.source) &&
    sameStr(prevOrder.currentCycle, nextOrder.currentCycle) &&
    sameStr(prevOrder.returnCount, nextOrder.returnCount)
  );
}

function isOrderSelected(selectedOrders, orderId) {
  if (!Array.isArray(selectedOrders) || orderId == null) return false;
  const id = String(orderId);
  return selectedOrders.some((x) => String(x) === id);
}

/**
 * Comparador para memo de BoardOrderRow / OpenColumnOrderRow / TechnicianOrderRow.
 * Ignora identidade de callbacks (assumidos estáveis via useCallback no Board).
 */
export function areBoardOrderRowPropsEqual(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if (prev.isStatusRetorno !== next.isStatusRetorno) return false;
  if (prev.isRetornoByRequestStatus !== next.isRetornoByRequestStatus) return false;
  if (prev.userShowOSConfig !== next.userShowOSConfig) return false;
  if (prev.showStatusColumnEmAberto !== next.showStatusColumnEmAberto) return false;
  if (prev.showDefeitoColumn !== next.showDefeitoColumn) return false;
  if (prev.loadingDefeitos !== next.loadingDefeitos) return false;
  if (prev.technician !== next.technician) return false;
  if (prev.groupName !== next.groupName) return false;
  if (!sameStr(prev.codstatusRetorno, next.codstatusRetorno)) return false;
  if (!sameStr(prev.codstatusPedidoVinculadoDisponivel, next.codstatusPedidoVinculadoDisponivel)) {
    return false;
  }

  const prevId = prev.ordem?.id ?? prev.ordem?.TB02115_CODIGO;
  const nextId = next.ordem?.id ?? next.ordem?.TB02115_CODIGO;
  const prevSelected =
    typeof prev.isSelected === 'boolean'
      ? prev.isSelected
      : isOrderSelected(prev.selectedOrders, prevId);
  const nextSelected =
    typeof next.isSelected === 'boolean'
      ? next.isSelected
      : isOrderSelected(next.selectedOrders, nextId);
  if (prevSelected !== nextSelected) return false;

  if (prev.showDefeitoColumn) {
    const prevKey = String(prev.ordem?.TB02115_CODIGO || prev.ordem?.id || '');
    const nextKey = String(next.ordem?.TB02115_CODIGO || next.ordem?.id || '');
    const prevDef = prev.defeitosData?.[prevKey];
    const nextDef = next.defeitosData?.[nextKey];
    if (prevDef !== nextDef) {
      if (!prevDef || !nextDef) return false;
      if (!sameStr(prevDef.defeito, nextDef.defeito)) return false;
    }
  }

  const prevExtras = prev.extraRetornoStatuses;
  const nextExtras = next.extraRetornoStatuses;
  if (prevExtras !== nextExtras) {
    const a = Array.isArray(prevExtras) ? prevExtras.join('|') : '';
    const b = Array.isArray(nextExtras) ? nextExtras.join('|') : '';
    if (a !== b) return false;
  }

  return areBoardOrderVisualFieldsEqual(prev.ordem, next.ordem);
}
